import {isDevEnv, Logger} from "@buildwithflux/shared";

import {AutoLayoutEventBus} from "./AutoLayoutEventBus";
import {
    DeepPcbAutoLayoutEventData,
    DeepPcbAutoLayoutEventMap,
    DeepPcbAutoLayoutEventType,
} from "./DeepPcbAutoLayoutEventBus";

export abstract class DeepPcbAutoLayoutBaseService {
    protected readonly logger: Logger;

    constructor(
        protected readonly serviceName: string,
        protected readonly eventBus: AutoLayoutEventBus<DeepPcbAutoLayoutEventMap>,
        logger: Logger,
    ) {
        this.serviceName = serviceName;

        this.logger = logger.child(
            {
                name: this.serviceName,
            },
            {
                level: isDevEnv() ? "debug" : "warn",
            },
        );
    }

    protected emit<T extends DeepPcbAutoLayoutEventType>(event: T, data: DeepPcbAutoLayoutEventData<T>): void {
        this.eventBus.emit(event, data, this.serviceName);
    }
}
